"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    endpoint: 'https://api.scheduleengine.net/se-analytics-service/v1/events',
};
